import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next'; // I18N
import Navbar from '../../components/Navbar/Navbar';
import PageTitle from '../../components/pagetitle/PageTitle'
import ContactSection from '../../components/ContactSection/ContactSection';
import Scrollbar from '../../components/scrollbar/scrollbar'
import Footer from '../../components/footer/Footer';
import Logo from "../../images/logo2.png"

const ContactPage = () => {
    const { t } = useTranslation(); // I18N
    return (
        <Fragment>
            <Navbar Logo={Logo} hclass={'wpo-site-header-s3'} />
            <PageTitle pageTitle={t('pageTitles.contact')} pagesub={t('pageTitles.contactSub')} />
            <ContactSection />
            <Footer />
            <Scrollbar />
        </Fragment>
    )
};
export default ContactPage;

